{
	"catalogMissingMessage": "There is no catalog found for this project. Would you like to create a new project with this folder?",
	"catalogMissingTitle": "Catalog missing",
	"createNew": "Create New",
	"openingProject": "Opening project...",
	"projectFolderMissingMessage": "Your project was not found in its expected location. Would you like to select its folder now?",
	"projectFolderMissingTitle": "Project folder missing",
	"selectProjectFolder": "Select Project Folder",
	"selectStyle": "Select Style",
	"styleMissingMessage": "We cannot find the style used for the project in the same folder. Would you like to select a new style for this project?",
	"styleMissingTitle": "Style missing or mismatch"
}
